import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { CAMPAIGN_COLUMNS } from '../helpers/consts';
import { useCampaignSearchDataColumn } from './useCampaignSearchDataColumn';
import { CampaignT } from '../../../lib/types/campaigns';
import { setSelectedCampaign } from '../../../lib/store/slices/campaignsSlice';
import { useAppDispatch } from '../../../lib/store/hooks';

const title = 'pages.campaigns.campaignTable.columns.campaignName';

export const useCampaignNameColumn = (
  handleClickCampaign: () => void,
  isSuperAdmin: boolean,
) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const onClickChevron = (row: CampaignT) => {
    if (isSuperAdmin) {
      dispatch(setSelectedCampaign(row));
      handleClickCampaign();
    }
  };

  return useCampaignSearchDataColumn({
    title: t(title),
    arrangedId: CAMPAIGN_COLUMNS.NAME,
    searchFieldName: 'searchByName',
    filterFieldName: 'includeNames',
    columnProps: {
      width: 320,
      render: (name: string, row: CampaignT) => {
        return (
          <span
            role="presentation"
            style={{ cursor: 'pointer' }}
            onClick={() => onClickChevron(row)}
          >
            <Typography.Text>{name}</Typography.Text>
          </span>
        );
      },
    },
  });
};
